export const EXTERNAL_SYNC_RESTRICTED_SOURCES = ['imanage', 'onedrive', 'sharepoint'] as const;

const SOURCE_DISPLAY_NAMES: Record<string, string> = {
  crimson: 'Crimson',
  outlook: 'Outlook',
  imanage: 'iManage',
  onedrive: 'OneDrive',
  sharepoint: 'SharePoint',
};

export function normalizeSource(source?: string | null): string {
  return String(source || '').toLowerCase();
}

export function isExternalSyncRestrictedSource(source?: string | null): boolean {
  return EXTERNAL_SYNC_RESTRICTED_SOURCES.includes(
    normalizeSource(source) as (typeof EXTERNAL_SYNC_RESTRICTED_SOURCES)[number]
  );
}

export function getSourceDisplayName(
  source?: string | null,
  fallback: string = 'external system'
): string {
  return SOURCE_DISPLAY_NAMES[normalizeSource(source)] ?? fallback;
}

export function getUploadSourceLabel(source?: string | null): string {
  const normalizedSource = normalizeSource(source);

  switch (normalizedSource) {
    case 'outlook':
      return 'Outlook Sync';
    case 'imanage':
      return 'iManage Sync';
    case 'onedrive':
      return 'OneDrive Sync';
    case 'sharepoint':
      return 'SharePoint Sync';
    default:
      return 'Manual upload';
  }
}
